import OpenInFull from "@mui/icons-material/OpenInFull";
import { IconButton, Tooltip } from "@mui/material";

interface AiAssistantMaximizeButtonProps {
  onMaximize: () => void;
}

export const AiAssistantMaximizeButton = ({
  onMaximize,
}: AiAssistantMaximizeButtonProps) => (
  <Tooltip title="Maximize">
    <IconButton
      size="small"
      onClick={onMaximize}
      className="text-text-secondary hover:text-text-primary -mb-0.5"
      data-test-id="ai-maximize-btn"
    >
      <OpenInFull fontSize="small" />
    </IconButton>
  </Tooltip>
);
